var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 566.93 377.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 283.46h425.2V0H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.3333 0 0 -1.3333 0 377.95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4993c1",
    d: "M0 0a6.966 6.966 0 01-6.969-6.959A6.977 6.977 0 010-13.931c3.838 0 6.961 3.121 6.961 6.972A6.96 6.96 0 010 0m82.451 109.09h-166.88V8.04h166.88zM11.101-7.02c0 6.204-5.024 11.206-11.213 11.206-6.208 0-11.243-5.002-11.243-11.206 0-6.198 5.02-11.226 11.243-11.226 6.203 0 11.213 5.028 11.213 11.226m85.251 116.94V-9.94c0-7.228-5.826-13.074-12.967-13.074H18.626s-3.674-26.167 19.638-26.167v-13.087H-40.25V-49.2c22.437 0 19.63 26.173 19.63 26.173h-64.727c-7.172 0-12.998 5.84-12.998 13.068v119.88c0 7.221 5.826 13.035 12.998 13.035h168.72c7.156 0 12.982-5.814 12.982-13.035",
    transform: "translate(281.61 119.57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70bde5",
    d: "M308.37 192.89h-98.809v26.197h98.809z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4993c1",
    d: "M308.37 160.69h-98.809v26.197h98.809z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1c74a",
    d: "M353.08 192.89h-38.043v26.197h38.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#175583",
    d: "M221.43 111.3H73.79v49.389h147.64zm18.51-.279c-5.03 8.655-4.522 21.154-4.522 21.154v50.999a5.67 5.67 0 01-5.669 5.669h-2.65a5.669 5.669 0 01-5.669-5.669v-5.27H73.79v5.27a5.669 5.669 0 01-5.669 5.669h-2.6a5.67 5.67 0 01-5.67-5.669v-50.999s.507-12.42-4.472-21.072c-4.63-.924-8.148-5.031-8.148-9.922V41.61c0-5.566 4.554-10.119 10.119-10.119h180.28c5.565 0 10.119 4.553 10.119 10.119v59.571c0 4.769-3.347 8.785-7.806 9.84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbox);
export default __webpack_public_path__ + "static/media/toolbox.88cff6f4599870a7e5f436cc1cc73cec.svg";
export { ForwardRef as ReactComponent };